// Custom helper functions

export const configuration = {
    sizePerPage: 3,

}   